import React from 'react';
import styles from './DeviceName.module.scss';

type Props = {
    name: string;
};

const DeviceName = ({ name }: Props): React.ReactElement => {
    return <h2 className={styles.title}>{name}</h2>;
};

export default DeviceName;
